module.exports = __webpack_public_path__ + "img/3.15f2c95b.png";